import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledSettings = styled.svg<IconProps>`
  & .cls-1,
  .cls-2 {
    fill: none;
  }

  & .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
  }
`;

const SettingsIcon: React.FC<IconProps> = props => {
  const activeclass = props.active ? 'active' : undefined;
  return (
    <StyledSettings
      id='Settings-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='User_Settings' data-name='User Settings' transform='translate(16 16)'>
        <path id='Margin' className='cls-1' d='M0,0H32V32H0Z' transform='translate(-16 -16)' />
        <g id='Group_13916' data-name='Group 13916' transform='translate(-17.486 -16.4)'>
          <path
            id='Path_11501'
            data-name='Path 11501'
            className='cls-2'
            d='M30.806,23.978a7.008,7.008,0,0,0-.1-1.008l1.824-1.615-1.6-2.769-2.32.785a5.786,5.786,0,0,0-1.729-1.008l-.479-2.385h-3.2l-.481,2.385A5.8,5.8,0,0,0,21,19.371l-2.32-.785-1.6,2.769L18.9,22.97a7.008,7.008,0,0,0-.1,1.008,7.008,7.008,0,0,0,.1,1.008L17.079,26.6l1.6,2.768L21,28.587a5.835,5.835,0,0,0,1.727,1.008l.481,2.383h3.2l.479-2.383a5.822,5.822,0,0,0,1.729-1.008l2.32.784,1.6-2.768-1.824-1.617A7.008,7.008,0,0,0,30.806,23.978Zm-6,3.2a3.2,3.2,0,1,1,3.2-3.2A3.21,3.21,0,0,1,24.807,27.179Z'
            transform='translate(-7.321 -7.578)'
          />
        </g>
      </g>
    </StyledSettings>
  );
};

export default SettingsIcon;
